/** A single bulk-setting block: title + optional hint + body + an Apply button. */
import type { ReactNode } from 'react';
import { Button } from '@vnetwork/ui/primitives';
import styles from './WafBulkConfigure.module.css';

export function BulkSection({
  title,
  hint,
  children,
  onApply,
  applyLabel = 'Apply',
  disabled,
  pending,
}: {
  title: string;
  hint?: string;
  children: ReactNode;
  onApply: () => void;
  applyLabel?: string;
  disabled?: boolean;
  pending?: boolean;
}) {
  return (
    <div className={styles.section}>
      <h3 className={styles.sectionTitle}>{title}</h3>
      {hint ? <p className={styles.sectionHint}>{hint}</p> : null}
      <div className={styles.sectionBody}>{children}</div>
      <div className={styles.applyRow}>
        <Button onClick={onApply} disabled={disabled || pending}>
          {pending ? 'Applying…' : applyLabel}
        </Button>
      </div>
    </div>
  );
}

export default BulkSection;
